import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';
import { onResultWithDataStatus } from 'Shared/HttpServices/Utils/utils';

import IGetCodeShenasehPardakhtShakhsSalesCommand from '../SakhsSalesBimehNameh/Commands/Soddor/IGetCodeShenasehPardakhtShakhsSalesCommand';
import { KhodroHttpPostService } from '../Services/KhodroHttpService';

export const getCodeShenasehPardakhtShakhsSalesChangePelak = createAsyncThunk(
  'getCodeShenasehPardakhtShakhsSalesChangePelak',
  async (command: IGetCodeShenasehPardakhtShakhsSalesCommand) => {
    return await KhodroHttpPostService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.CreateShenasehPardakhtChangePelak}`,
      body: command,

      onResult: onResultWithDataStatus,
    });
  }
);
